import * as React from "react";
const SvgLeverans = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 30.51 31.83",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("path", {
	d: "m13.31 0-4 2.3 16.8 8.92-.31 8.48-4.3 2 .38-8.38-16.44-8.9L.51 7.08 0 23.32l16.56 8.51 13.72-7.47.23-15.82Zm-3.22 24.24-6.92-3.55.13-4 7 3.75Z",
	"data-name": "Layer 1"
})));
export default SvgLeverans;
